const loadScript = ({ id, url, callback }) => {
    if (document.getElementById(id)) return;
    var s = document.createElement('script');
    s.id = id;
    // s.async = false;
    s.src = url;
    s.type = 'text/javascript';
    s.onload = callback ? callback : null;
    (document.getElementsByTagName('head')[0] || document.body).appendChild(s);
};

const waitForObject = (name, callback) => {
    var interval = 10;
    var isDefined = function (name) {
        var parts = name.split('.'),
            len = parts.length,
            obj = window,
            i;
        for (i = 0; i < len; i += 1) {
            if (typeof obj[parts[i]] === 'undefined') return false;
            obj = obj[parts[i]];
        }
        return true;
    };
    window.setTimeout(function () {
        if (isDefined(name)) {
            callback();
        } else {
            window.setTimeout(arguments.callee, interval);
        }
    }, interval);
};

const loadJSON = ({ url, successCallback, errorCallback }) => {
    const loadJSONfromUrl = (url, callbacks) => {
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then((response) => {
                if (callbacks.success) {
                    callbacks.success(response);
                }
            })
            .catch((error) => {
                if (callbacks.error) {
                    callbacks.error(error);
                }
            });
    };

    loadJSONfromUrl(url, {
        success: (response) => {
            if (successCallback) {
                successCallback(response);
            }
        },
        error: (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        }
    });
};

const getBaseURL = () => {
    return document.URL.substring(0, document.URL.lastIndexOf('/'));
};

const getBaseURLWithDailyRefresh = (baseURL) => {
    const d = new Date();
    const dS = d.getFullYear() * 10000 + d.getMonth() * 100 + d.getDate();
    baseURL = baseURL ? baseURL : getBaseURL();
    return baseURL.replace('/ui/', '/ui/' + dS + '/');
};

export { loadScript, waitForObject, loadJSON, getBaseURL, getBaseURLWithDailyRefresh };
